import { AlertTriangle, CheckCircle2, Clock3, Search } from "lucide-react";
import { Badge } from "../components/ui";

export function SeverityChip({
  fgseverity,
  fgstatus,
  fgrequire,
  nrfiles,
}: {
  fgseverity: number;
  fgstatus: number;
  fgrequire?: number;
  nrfiles?: number;
}) {
  if (fgstatus === 2) {
    return (
      <Badge
        variant="outline"
        className="rounded-full border-blue-200 bg-blue-50 text-blue-800"
      >
        <Search size={14} />
        Em análise · nada a fazer
      </Badge>
    );
  }
  if (fgrequire === 2 && fgstatus === 1 && Number(nrfiles ?? 0) === 0) {
    return (
      <Badge
        variant="outline"
        className="rounded-full border-amber-200 bg-amber-50 text-amber-800"
      >
        <Clock3 size={14} />
        Pendente
      </Badge>
    );
  }
  if (fgseverity === 3) {
    return (
      <Badge
        variant="outline"
        className="rounded-full border-red-200 bg-red-50 text-red-700"
      >
        <AlertTriangle size={14} />
        Resolver agora
      </Badge>
    );
  }
  if (fgseverity === 2) {
    return (
      <Badge
        variant="outline"
        className="rounded-full border-amber-200 bg-amber-50 text-amber-800"
      >
        <Clock3 size={14} />
        Vence em breve
      </Badge>
    );
  }
  return (
    <Badge
      variant="outline"
      className="rounded-full border-teal-200 bg-teal-50 text-teal-800"
    >
      <CheckCircle2 size={14} />
      Concluído
    </Badge>
  );
}
